import { render } from "./deals.vue?vue&type=template&id=7a6cb60b&scoped=true"
import script from "./deals.vue?vue&type=script&lang=js"
export * from "./deals.vue?vue&type=script&lang=js"

import "./deals.vue?vue&type=style&index=0&id=7a6cb60b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6cb60b"]])

export default __exports__